<template lang="pug">
  .component-vehicle-damage-detail

    .damage-container(ref="damageContainer")
      img.car-outline(:src="vehicleDamagePicture")
      .component-pin(v-for="(pin) in pins", :style="{backgroundColor: pin.status === 'PENDING_REVIEW' ? '#ffc200' : '#2890ff', top:pin.top+'px', left: pin.left + 'px'}", :class="{'is-expanded':pin.expanded, hover: pin.hover, 'status-PENDING_REVIEW': true}", @mouseover="selectHovered(pin)", @mouseleave="resetHover")
        div(@click="pin.expanded = !pin.expanded" )
          small {{pin.id}}
        .expanded(v-if="pin.expanded", @click="pin.expanded = !pin.expanded")
          .row
            .column
              label ID
              router-link(:to="{name:'reporting',params:{id:pin.id}}", target='_blank') {{pin.id}}
            .column
              label UID
              .value {{pin.uid}}
            .column
              label Status
              .value {{pin.status}}

          hr
          .row
            .column
              label Description
              p {{pin.description}}


</template>
<script type="text/babel">

export default {
  name: 'VehicleDamageDetail',
  components: {},
  data() {
    return {
      pins: [],
      rendered: false,
    }
  },
  mounted() {
  },
  methods: {
    render() {
      var container = this.$refs.damageContainer
      this.items.forEach((item, key) => {
        this.pins.splice(key, 1, {
          id: item.id ? item.id : null,
          uid: item.uid ? item.uid : null,
          containerWidth: item.containerWidth,
          containerHeight: item.containerHeight,
          left: ((item.left) * container.clientWidth) / item.containerWidth,
          top: ((item.top) * container.clientHeight) / item.containerHeight,
          expanded: false,
          hover: false,
          description: item.description ? item.description : null,
          status: item.status ? item.status : null,
          created_at: item.created_at ? item.created_at : null,
        })
      })

    },
    resetHover() {
      this.pins.forEach((item) => {
        item.hover = false
      })
    },
    selectHovered(pin) {
      this.pins.filter((item) => {
        return pin.id === item.id
      }).forEach((item) => {
        item.hover = true
      })
    },


  },
  computed: {},
  props: {
    items: {
      required: true,
      type: Array
    },

    vehicleDamagePicture: {
      required: true
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-vehicle-damage-detail
  .component-pin
    display: flex
    justify-content: center
    align-items: center

    &.is-expanded
      z-index: 99
      background: #d4ecf2!important

    &.hover
      background: #d4ecf2!important
      border: 2px dashed #5EB9CF
      z-index: 99

    &:hover
      cursor: pointer
      background: #d4ecf2!important
      border: 2px dashed #5EB9CF
      z-index: 99

    .expanded
      position: absolute
      background: white
      border: 1px #cacaca solid
      border-radius: 10px
      top: 160px
      left: 50%
      padding: 1em
      width: 20rem
      transform: translate(-50%, -50%)
</style>



// WEBPACK FOOTER //
// VehicleDamageDetail.vue?4a9d2d47